import VTreemap from './components/VTreemap'

const VueTreemap = {
  install(Vue) {
    Vue.component(VTreemap.name, VTreemap)
  }
}

export default VueTreemap

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(VueTreemap)
}
